var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-full',{staticClass:"btn btn-primary btn-buy",attrs:{"disabled":_vm.isProductDisabled,"data-testid":"addToCart"},nativeOn:{"click":function($event){return _vm.addToCart(_vm.product)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('Add to cart')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }